import { Braintree_credit_card } from './braintree_credit_card';

export class Braintree_customer {
	customer_id: string;
	first_name: string;
	last_name: string;
	telephone: string;
	email: string;
	user_id: string;
	system_customer_id: string;
	date_created: Date;
	credit_card_list: Braintree_credit_card[] = [];
	hidden: boolean;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}


}